module.exports = new __parcel__URL__("react.8e920840.svg").toString();